import React from 'react';
import { View, StyleSheet, type StyleProp, type ViewStyle } from 'react-native';

/**
 * Shell for legend + control: matches {@link SimplePermissionWrapper} `container` so each field is
 * one flex item under {@link FormFieldStack} (RN Web avoids splitting label/input across stack gap).
 */
export const formFieldGroupShell = StyleSheet.create({
  root: {
    width: '100%' as const,
    flexDirection: 'column' as const,
    alignItems: 'stretch' as const,
    alignSelf: 'stretch' as const,
  },
});

export type FormFieldGroupProps = {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

/**
 * Wrap external legend + control (`FormFieldLabelWithInfo` + `hideLabel` input) in one host node.
 */
export function FormFieldGroup({ children, style, testID }: FormFieldGroupProps): React.ReactElement {
  return (
    <View style={[formFieldGroupShell.root, style]} testID={testID}>
      {children}
    </View>
  );
}

FormFieldGroup.displayName = 'FormFieldGroup';
